import { DatePicker } from "antd";
import { filterButtonPressed, moveSelectedFiltersToApplied, updateCampaignLimit } from "modules/Analytics/actions";
import { analyticsDatesFilterChange, updateAssetListOnDateFilter } from "modules/Analytics/Dashboard/actions";
import SelectWithIcon from "modules/Campaigns/Shared/SelectWithIcon";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import styled from "styled-components";
import { ReactComponent as CalenderIcon } from "../../../assets/img/icons/Campaign/Calender.svg";
import Send from "../../../assets/img/icons/Send.svg";
import ButtonRightIcon from "../../Common/Components/ButtonRightIcon";
import { ANALYTICS_DEFAULT_DATES_FILTER } from "../Contacts/utils";
import AssetsFiltersDropdown from "../Shared/AssetsFiltersDropdown";
import CampaignFiltersDropdown from "../Shared/CampaignFiltersDropdown";
import { getAllAnalyticsTab } from "../utils";

interface IAnalyticsFiltersProps {
  hidden?: boolean;
  page: string;
  searchedText: string;
  tab?: string;
}

const AnalyticsFilters: React.FC<IAnalyticsFiltersProps> = ({ hidden, page, searchedText, tab }) => {
  const onExportAnalyticsData = () => getAllAnalyticsTab(page, searchedText, tab);
  const datesOptions = useSelector((state: RootState) => state.analyticsGraph.dates);
  const disableExportButton = useSelector((state: RootState) => state.analyticsDashboard.exportLoading);
  const selectedAssetIds = useSelector((state: RootState) => state.analyticsDashboard.selectedAssetsIds);
  const selectedCampaignIds = useSelector((state: RootState) => state.analyticsDashboard.selectedCampaignsIds);
  const selectedDatesObject = useSelector((state: RootState) => state.analyticsGraph.selectedDatesObject);
  const [isFilterDisabled, setIsFilterDisabled] = useState(true);
  const firstAllDataShown = useSelector((state: RootState) => state.analyticsDashboard.firstAllDataShown);
  const { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = useSelector(
    (state: RootState) => state.analyticsDashboard
  );

  useEffect(() => {
    if (
      selectedCampaignIds.length === 0 &&
      selectedAssetIds.length === 0 &&
      selectedDatesObject?.value === ANALYTICS_DEFAULT_DATES_FILTER.value
    ) {
      if (isFilterDisabled !== true) {
        setIsFilterDisabled(true);
        // moveSelectedFiltersToApplied();
      }
    } else {
      if (isFilterDisabled !== false) {
        setIsFilterDisabled(false);
      }
    }
  }, [selectedAssetIds, selectedCampaignIds, selectedDatesObject]);

  function closeDropDownHandler() {
    // action to change the state 'campaignsLimitReached' so that when a
    // dropdown closed the message of limit should disappear
    updateCampaignLimit(false);
  }

  return (
    <Wrapper>
      <div className={`tabs-wrapper padding-top-md padding-bottom-md ${hidden ? "invisible d-none" : "d-flex"}`}>
        <ul className="d-flex justify-content-between w-100">
          <li>
            <ul>
              <li>
                <CampaignFiltersDropdown
                  dropdownClass="dropdown-menu-wrapper"
                  closeDropDownHandler={closeDropDownHandler}
                />
              </li>
              <li>
                <AssetsFiltersDropdown closeDropDownHandler={closeDropDownHandler} />
              </li>
              <li className={`custom-size ${firstAllDataShown ? "" : "disabled"}`}>
                <SelectWithIcon
                  emoji={<CalenderIcon style={{ height: 18, width: 18 }} />}
                  options={datesOptions}
                  heightWidth={15}
                  value={selectedDatesObject}
                  {...(analyticsDatesFilterChange
                    ? {
                      onChange: (value) => {
                        analyticsDatesFilterChange(value);
                        // updateAssetListOnDateFilter(value);
                      },
                    }
                    : {})}
                  customDatePicker={<DatePicker bordered={false} />}
                  isAnalytics={true}
                />
              </li>
              <li>
                {/* {!isFilterDisabled && (
                // (selectedAssetIds.length === 0 && !AllCampaignsFilterCheck ? (
                //   <Tooltip placement="top" title={"select an email"}>
                //     <div style={{ height: "100%" }}>
                //       <ButtonRightIcon
                //         noIcon
                //         label={"Apply Filters"}
                //         green={true}
                //         outlineClass="auto-width mt-0 h-100"
                //         onClick={() => filterButtonPressed(true)}
                //         disable
                //       />
                //     </div>
                //   </Tooltip>
                // ) : ( */}
                <div className="apply-filters">
                  <ButtonRightIcon
                    noIcon
                    label="Apply Filters"
                    green={true}
                    disable={
                      isShareProfile || isDailyIQ || isWeeklyAccountInsights
                        ? false
                        : !selectedCampaignIds.length || !selectedAssetIds.length
                    }
                    outlineClass="auto-width mt-0 h-100"
                    onClick={() => filterButtonPressed(true)}
                  />
                </div>
                {/* )} */}
              </li>
            </ul>
          </li>

          <li>
            <ul>
              {
                !window.location.pathname.includes("trends")
                && !window.location.pathname.includes("journey")
                && !window.location.pathname.includes("insights")
                && (
                  <li className={`right export`}>
                    <ButtonRightIcon
                      label="Export"
                      onClick={onExportAnalyticsData}
                      icon={Send}
                      outlineClass="auto-width"
                      disable={disableExportButton}
                    />
                  </li>
                )}
            </ul>
          </li>
        </ul>
      </div>
    </Wrapper>
  );
};

export default React.memo(AnalyticsFilters);

const Wrapper = styled.div`
  .apply-filters > button {
    /* font-size: 14px; */
    min-height: 38px;
    /* width: 110px; */
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-height: 30px;
    }
  }
  .export.right > button {
    /* font-size: 14px; */
    min-height: 38px;
    /* width: 110px;*/
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-height: 30px;
    }
    /*span.label {
      min-width: 36px;
    } */
  }
`;
